const system_limit = {
    limit_exceeded: 'Osiągnięto limit systemu. Skontaktuj się z pomocą techniczną, aby uzyskać wsparcie.',
};
export default Object.freeze(system_limit);
